import React, { useEffect } from 'react'
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchSalaryById } from '../reducers/SalarySlice';
import moment from 'moment/moment';
const ViewSalary = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { salary, status, error } = useSelector(state => state.salaries);

    useEffect(() => {
        if (id) {
            dispatch(fetchSalaryById(id));
        }
    }, [id, dispatch]);

    if (status === 'loading') {
        return <div className="d-flex justify-content-center align-items-center h-100"><CircularProgress /></div>;
    }

    if (status === 'failed') {
        return <div>Failed to load salary data: {error}</div>;
    }

    if (!salary) {
        return <div>No Salary data available.</div>;
    }

    return (
        <>
            <div className="container my-4 text-white view-room">
                <div className="row" id="roomContainer">
                    <div className="col">
                        <div className="card-body">
                            <div className="card room-card p-4">
                                <h2 className="text-center text-white mb-2">AK Boys Hostel</h2>
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-100 text-white border border-gray-300 shadow-md rounded-lg">
                                        <tbody>
                                            {[
                                                ["Employee ID", salary?._id, "Employee Name", salary?.fullName],
                                                ["Employee Type", salary?.employeeType, "Salary", salary?.basicSalary],
                                            ].map((row, rowIndex) => (
                                                <tr key={rowIndex} className="border-b border-gray-300">
                                                    {row.map((cell, cellIndex) => (
                                                        <td key={cellIndex} className="px-4 py-2 border border-gray-300">
                                                            <strong>{cellIndex % 2 === 0 ? cell : ""}</strong> {cellIndex % 2 !== 0 ? (typeof cell === "number" ? `${cell.toLocaleString()} PKR` : cell) : ""}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="payment-history-section mt-4">
                                    <h3 className="text-center text-white mb-2">Payment History</h3>
                                    <div className="table-responsive">
                                        {salary?.salaryHistory && salary.salaryHistory.length > 0 ? (
                                            <table className="table table-bordered table-striped text-white">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Basic Salary</th>
                                                        <th>Allowances</th>
                                                        <th>Deductions</th>
                                                        <th>Net Salary</th>
                                                        <th>Salary Month</th>
                                                        <th>Payment Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {salary?.salaryHistory.map((payment, index) => (
                                                        <tr key={payment._id}>
                                                            <td>{index + 1}</td>
                                                            <td>{payment.basicSalary?.toLocaleString() || 'N/A'}</td>
                                                            <td>{payment.allowances?.toLocaleString() || 'N/A'}</td>
                                                            <td>{payment.deductions?.toLocaleString() || 'N/A'}</td>
                                                            <td>{payment.netSalary?.toLocaleString() || 'N/A'}</td>
                                                            <td>{payment.salaryMonth?.toLocaleString() || 'N/A'}</td>
                                                            <td>{payment.paymentDate ? moment(payment.paymentDate).format('DD-MM-YYYY') : 'N/A'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div>No Payment History Available</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewSalary
